import {FormikValues, useFormik} from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'
import {useEffect, useState} from 'react'
// import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'
import styles from '../LeadManagementStyles/LeadManagementStyle.module.css'
import Swal from 'sweetalert2'
import { Get_Province} from '../../property/Property_Api'
import { provinceDataType} from '../../property/PropertyDataTypes'
import DatePicker from 'react-datepicker'
import {addLead} from '../LeadManagementAPI'
import {useNavigate} from 'react-router'
import * as Yup from 'yup'

const NewLeadsForm = () => {
  const navigate = useNavigate()
  // const {executeRecaptcha} = useGoogleReCaptcha()
  const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)
  const [province, setProvince] = useState<provinceDataType[]>([])
  const [employmentType, setEmploymentType] = useState<string>('Salaried')
  const [moveInDate, setMoveInDate] = useState<Date | null>(null)

  // Create an event handler so you can call the verification on button click event or form submit
  // const handleReCaptchaVerify = useCallback(async () => {
  //   if (!executeRecaptcha) {
  //     console.log('Execute recaptcha not yet available')
  //     return
  //   }

  //   const token = await executeRecaptcha('newLeadFormSubmission')
  //   // console.log('Token', token)
  //   // Do whatever you want with the token
  // }, [executeRecaptcha])

  // You can use useEffect to trigger the verification as soon as the component being loaded
  // useEffect(() => {
  //   handleReCaptchaVerify()
  // }, [handleReCaptchaVerify])

  // initial values for new leads form
  const NewLeadsFormInitialValues = {
    full_name: '', //mandetory
    phone_number: '', //mandetory
    email: '', //mandetory
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    pincode: '',
    property_type: '',
    prefferd_loc: '',
    no_room: '', //number
    no_toilet: '', //number
    min_price: '', //number
    max_price: '', //number
    pet_friendly: '',
    tenancy_period: '',
    tenancy_start: '',
    employment_type: '',
    employment_length: '',
    monthly_income: '',
    other_requirement: '',
    contact_mode: '', //mandetory
    business_name: '',
    current_employer: '',
    verifyCheckbox: '',
  }

  // validation schema for new leads form
  const newLeadsFormValidationSchema = Yup.object().shape({
    full_name: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(200, 'Maximum 200 characters')
      .required('Full name is required'), //mandetory
    phone_number: Yup.string()
      .required('Phone number is required.')
      .matches(/^\+\d{2} \d{5}-\d{5}$/, 'Please use the format "+91 99999-99999"'), //mandetory
    email: Yup.string()
      .email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Email address is required'), //mandetory
    address_1: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(600, 'Maximum 600 characters')
      .optional(),
    address_2: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(600, 'Maximum 600 characters')
      .optional(),
    city: Yup.string().min(3, 'Minimum 3 characters').max(100, 'Maximum 100 characters').optional(),
    state: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(100, 'Maximum 100 characters')
      .optional(),
    pincode: Yup.number()
      .typeError('Pincode must be a number')
      .positive('Pincode must be a positive number')
      .integer('Pincode must be an integer')
      .min(100000, 'Pincode must be at least 6 digits')
      .max(999999, 'Pincode cannot be more than 6 digits')
      .optional(),
    property_type: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(350, 'Maximum 350 characters')
      .optional(),
    prefferd_loc: Yup.string()
      .min(3, 'Minimum 3 characters')
      .max(350, 'Maximum 350 characters')
      .optional(),
    no_room: Yup.number()
      .typeError('Number of rooms must be a number')
      .positive('Number of rooms must be a positive number')
      .integer('Number of rooms must be an integer')
      .optional(), //number
    no_toilet: Yup.number()
      .typeError('Number of bathrooms must be a number')
      .positive('Number of bathrooms must be a positive number')
      .integer('Number of bathrooms must be an integer')
      .optional(), //number
    min_price: Yup.number()
      .typeError('Min price range must be a number')
      .positive('Min price range must be a positive number')
      .integer('Min price range must be an integer')
      .optional(), //number
    max_price: Yup.number()
      .typeError('Max price range must be a number')
      .positive('Max price range must be a positive number')
      .integer('Max price range must be an integer')
      .optional(), //number
    pet_friendly: Yup.string().optional(),
    tenancy_period: Yup.number()
      .typeError('Preferred rental duration must be a number')
      .positive('Preferred rental duration must be a positive number')
      .integer('Preferred rental duration must be an integer')
      .optional(),
    tenancy_start: Yup.string().optional(),
    employment_type: Yup.string().optional(),
    employment_length: Yup.number()
      .typeError('Length of employment must be a number')
      .positive('Length of employment must be a positive number')
      // .integer('Length of employment must be an integer')
      .optional(), //number,
    monthly_income: Yup.string().optional(),
    other_requirement: Yup.string().optional(),
    contact_mode: Yup.array()
      .required('Preferred contact method is required')
      .test('at-least-one-checked', 'At least one option must be selected', (value: any) => {
        return value && value.length > 0
      }), //mandetory
    business_name: Yup.string().optional(),
    current_employer: Yup.string().optional(),
    verifyCheckbox: Yup.string().required('Please check this box to proceed'), //mandetory
  })

  // function to add new leads
  const handleAddLead = async (values: FormikValues) => {
    setSubmitBtnLoading(true)
    try {
      const {data: response} = await addLead(
        values.full_name,
        values.phone_number,
        values.email,
        values.contact_mode,
        values.address_1,
        values.address_2,
        values.city,
        values.state,
        values.pincode,
        values.property_type,
        values.prefferd_loc,
        values.no_room ? parseInt(values.no_room, 10) : '',
        values.no_toilet ? parseInt(values.no_toilet, 10) : '',
        values.min_price ? parseInt(values.min_price, 10) : '',
        values.max_price ? parseInt(values.max_price, 10) : '',
        values.pet_friendly,
        values.tenancy_period ? `${values.tenancy_period} year` : values.tenancy_period,
        values.tenancy_start,
        values.employment_type,
        values.employment_length ? `${values.employment_length} year` : values.employment_length,
        values.monthly_income,
        values.other_requirement,
        values.employment_type === 'Salaried' ? values.current_employer : '',
        values.employment_type === 'self employment' ? values.business_name : ''
      )
      if (response.code === '200') {
        navigate('/lead_management/lead-dashboard')
        formik.resetForm()
        setEmploymentType('Salaried')
        setMoveInDate(null)
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setSubmitBtnLoading(false)
    }
  }
  const formik = useFormik({
    initialValues: NewLeadsFormInitialValues,
    // enableReinitialize: true,
    validationSchema: newLeadsFormValidationSchema,
    onSubmit: (values) => handleAddLead(values),
  })

  // function to get Province/state
  async function getProvince(country: number) {
    try {
      const {data: res} = await Get_Province(country)
      if (res.code === '200') {
        setProvince(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // function to format date
  const formatDate = (date: Date) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formattedDate
  }

  // onload fetch states/province
  useEffect(() => {
    getProvince(1)
  }, [])
  return (
    <div className='card p-10'>
      {/* Begin: form */}
      <form onSubmit={formik.handleSubmit}>
        {/* Begin: section Contact details */}
        {/* Begin: heading Contact details */}
        <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Contact details</h2>
        {/* End: heading Contact details */}
        <div className='row justify-content-between w-100'>
          {/*Begin::Form Group Full Name */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Full Name</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter full name'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter full Name '
              {...formik.getFieldProps('full_name')}
              name='full_name'
            />
            <div className='h-20px'>
              {formik.touched.full_name && formik.errors.full_name && (
                <div className='fv-help-block color-red'>{formik.errors.full_name}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Full Name */}

          {/*Begin::Form Group Phone Number */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Phone Number</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter phone number'
              ></i>
            </label>
            <MuiPhoneNumber
              {...formik.getFieldProps('phone_number')}
              className='w-100'
              defaultCountry={'in'}
              onChange={(value) => formik.setFieldValue('phone_number', value)}
            />
            <div className='h-20px'>
              {formik.touched.phone_number && formik.errors.phone_number && (
                <div className='fv-help-block color-red'>{formik.errors.phone_number}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Phone Number */}

          {/*Begin::Form Group Email ID */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Email ID</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter email ID'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter email ID'
              {...formik.getFieldProps('email')}
              name='email'
            />
            <div className='h-20px'>
              {formik.touched.email && formik.errors.email && (
                <div className='fv-help-block color-red'>{formik.errors.email}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Email ID */}

          {/* Begin: Form Group Preferred Contact Method */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className=' col-form-label fw-bold p-0 mb-2'>
              <span className='required fs-5 fw-semibold mb-2'>Preferred Contact Method</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Specify preferred contact method'
              ></i>
            </label>
            <div className='w-100 col-lg-8 fv-row'>
              <div className='row'>
                {/*begin:Option Email */}
                <label className='col-lg-2 d-flex flex-fill align-items-center justify-content-between cursor-pointer px-2'>
                  <span className='d-flex align-items-center'>
                    <span className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-primary'>
                        <i
                          className={`bi bi-envelope-paper-fill fs-2 ${
                            formik.values.contact_mode.includes('Email') && 'text-primary'
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column me-4'>
                      <span className='fw-bolder fs-6'>Email</span>
                    </span>
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        style={{accentColor: '#ac4481'}}
                        {...formik.getFieldProps('contact_mode')}
                        name='contact_mode'
                        className='form bg-primary me-4'
                        type='checkbox'
                        value='Email'
                        id='contact_mode'
                      />
                    </div>
                  </span>
                </label>
                {/*end::Option Email */}

                {/*begin:Option SMS */}
                <label className='col-lg-2 d-flex flex-fill align-items-center justify-content-between cursor-pointer px-2'>
                  <span className='d-flex align-items-center'>
                    <span className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-primary'>
                        <i
                          className={`bi bi-chat-left-dots-fill fs-2 ${
                            formik.values.contact_mode.includes('SMS') && 'text-primary'
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column me-4'>
                      <span className='fw-bolder fs-6'>SMS</span>
                    </span>
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        style={{accentColor: '#ac4481'}}
                        {...formik.getFieldProps('contact_mode')}
                        className='form bg-primary me-4'
                        type='checkbox'
                        value='SMS'
                        id='contact_mode'
                      />
                    </div>
                  </span>
                </label>
                {/*end::Option SMS */}
                {/*begin:Option Phone */}
                <label className='col-lg-2 d-flex flex-fill align-items-center justify-content-between cursor-pointer px-2'>
                  <span className='d-flex align-items-center'>
                    <span className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-primary'>
                        <i
                          className={`bi bi-telephone-fill fs-2 ${
                            formik.values.contact_mode.includes('Phone') && 'text-primary'
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column me-4'>
                      <span className='fw-bolder fs-6'>Phone</span>
                    </span>
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        style={{accentColor: '#ac4481'}}
                        {...formik.getFieldProps('contact_mode')}
                        name='contact_mode'
                        className='form bg-primary me-4'
                        type='checkbox'
                        value='Phone'
                        id='contact_mode'
                      />
                    </div>
                  </span>
                </label>
                {/*end::Option Phone */}
              </div>
              <div className='h-20px'>
                {formik.touched.contact_mode && formik.errors.contact_mode && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.contact_mode.toString()}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* End: Form Group Preferred Contact Method */}

          {/*Begin::Form Group Address Line 1 */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Address Line 1</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter complete address'
              ></i>
            </label>
            <textarea
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter address'
              {...formik.getFieldProps('address_1')}
              name='address_1'
            />
            <div className='h-20px'>
              {formik.touched.address_1 && formik.errors.address_1 && (
                <div className='fv-help-block color-red'>{formik.errors.address_1}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Address Line 1 */}

          {/*Begin::Form Group Address Line 2*/}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Address Line 2</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter complete address'
              ></i>
            </label>
            <textarea
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter address'
              {...formik.getFieldProps('address_2')}
              name='address_2'
            />
            <div className='h-20px'>
              {formik.touched.address_2 && formik.errors.address_2 && (
                <div className='fv-help-block color-red'>{formik.errors.address_2}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Address Line 2*/}

          {/*Begin::Form Group Province/State*/}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Province/State</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose your province/state'
              ></i>
            </label>
            <select
              className='form-select form-select-solid'
              placeholder='Select province/state'
              {...formik.getFieldProps('state')}
              name='state'
            >
              <option className='bg-color-gray' value=''>
                Select province/state
              </option>
              {province.map((item) => {
                return (
                  <option key={item.province_id} value={item.province_name}>
                    {item.province_name}
                  </option>
                )
              })}
            </select>
            <div className='h-20px'>
              {formik.touched.state && formik.errors.state && (
                <div className='fv-help-block color-red'>{formik.errors.state}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Province/State*/}

          {/*Begin::Form Group city*/}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>City</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter city name'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter city'
              {...formik.getFieldProps('city')}
              name='city'
            />
            <div className='h-20px'>
              {formik.touched.city && formik.errors.city && (
                <div className='fv-help-block color-red'>{formik.errors.city}</div>
              )}
            </div>
          </div>
          {/*end::Form Group city*/}

          {/*Begin::Form Group PIN/Postcode*/}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>PIN/Postcode</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter PIN/Postcode'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter PIN/Postcode'
              {...formik.getFieldProps('pincode')}
              name='pincode'
            />
            <div className='h-20px'>
              {formik.touched.pincode && formik.errors.pincode && (
                <div className='fv-help-block color-red'>{formik.errors.pincode}</div>
              )}
            </div>
          </div>
          {/*end::Form Group PIN/Postcode*/}
        </div>
        {/* End: section Contact details */}

        <hr className='py-2 text-primary' />

        {/* Begin: Section Property Preferences */}
        {/* Begin: Heading Property Preferences */}
        <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
          Property Preferences
        </h2>
        {/* End: Heading Property Preferences */}
        <div className='row justify-content-between w-100'>
          {/*Begin::Form Group Preferred Location */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Preferred Location</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter preferred location'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter preferred location'
              {...formik.getFieldProps('prefferd_loc')}
              name='prefferd_loc'
            />
            <div className='h-20px'>
              {formik.touched.prefferd_loc && formik.errors.prefferd_loc && (
                <div className='fv-help-block color-red'>{formik.errors.prefferd_loc}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Preferred Location */}
          {/*Begin::Form Group Property Type */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Property Type</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter property type'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter property type'
              {...formik.getFieldProps('property_type')}
              name='property_type'
            />
            <div className='h-20px'>
              {formik.touched.property_type && formik.errors.property_type && (
                <div className='fv-help-block color-red'>{formik.errors.property_type}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Property Type */}
          {/*Begin::Form Group Number of bedrooms */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Number of bedrooms</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter number of bedrooms preferred'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter number of bedrooms'
              {...formik.getFieldProps('no_room')}
              name='no_room'
            />
            <div className='h-20px'>
              {formik.touched.no_room && formik.errors.no_room && (
                <div className='fv-help-block color-red'>{formik.errors.no_room}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Number of bedrooms */}
          {/*Begin::Form Group Number of Bathrooms */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Number of Bathrooms</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter number of bathrooms preferred'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter number of bathrooms'
              {...formik.getFieldProps('no_toilet')}
              name='no_toilet'
            />
            <div className='h-20px'>
              {formik.touched.no_toilet && formik.errors.no_toilet && (
                <div className='fv-help-block color-red'>{formik.errors.no_toilet}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Number of Bathrooms */}
          {/*Begin::Form Group Min Price Range */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Min Price Range</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter min price range'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter min price range'
              {...formik.getFieldProps('min_price')}
              name='min_price'
            />
            <div className='h-20px'>
              {formik.touched.min_price && formik.errors.min_price && (
                <div className='fv-help-block color-red'>{formik.errors.min_price}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Min Price Range */}
          {/*Begin::Form Group Max Price Range */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Max Price Range</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter max price range'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter max price range'
              {...formik.getFieldProps('max_price')}
              name='max_price'
            />
            <div className='h-20px'>
              {formik.touched.max_price && formik.errors.max_price && (
                <div className='fv-help-block color-red'>{formik.errors.max_price}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Max Price Range */}
          {/*Begin::Form Group Pet-Friendly Preference */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className=' col-form-label fw-bold px-0'>
              <span className='fs-5 fw-semibold mb-2'>Pet-Friendly Preference</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose your preference for pet'
              ></i>
            </label>
            <div className='w-100 col-lg-8 fv-row'>
              <div className='row'>
                {/*begin:Option required*/}
                <label className='col-lg-3 d-flex flex-fill align-items-center justify-content-between cursor-pointer px-2'>
                  <span className='d-flex align-items-center me-2'>
                    <span className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-primary'>
                        <i
                          className={`bi bi-check-lg fs-1 ${
                            formik.values.pet_friendly === 'yes' && 'text-primary'
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column'>
                      <span className='fw-bolder fs-6'>Required</span>
                    </span>
                  </span>

                  <span className='form-check form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      {...formik.getFieldProps('pet_friendly')}
                      name='pet_friendly'
                      type='radio'
                      value='yes'
                      id='pet_friendly'
                    />
                  </span>
                </label>
                {/*end::Option required*/}

                {/*begin:Option not requied */}
                <label className='col-lg-3 d-flex flex-fill align-items-center justify-content-between cursor-pointer px-2'>
                  <span className='d-flex align-items-center me-2'>
                    <span className='symbol symbol-50px me-2'>
                      <span className='symbol-label bg-light-primary'>
                        <i
                          className={`bi bi-x-lg fs-2 ${
                            formik.values.pet_friendly === 'no' && 'text-primary'
                          }`}
                        ></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column'>
                      <span className='fw-bolder fs-6'>Not required</span>
                    </span>
                  </span>

                  <span className='form-check form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      {...formik.getFieldProps('pet_friendly')}
                      name='pet_friendly'
                      type='radio'
                      value='no'
                      id='pet_friendly'
                    />
                  </span>
                </label>
                {/*end::Option not requied */}
              </div>
              <div className='h-20px'>
                {formik.touched.pet_friendly && formik.errors.pet_friendly && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.pet_friendly.toString()}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/*End::Form Group Pet-Friendly Preference */}
          {/*Begin::Form Group Preferred Move-In Date */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Preferred Move-In Date</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter preferred move-in date'
              ></i>
            </label>
            <DatePicker
              autoComplete='off'
              selected={moveInDate}
              dateFormat='yyyy/MM/dd'
              placeholderText='Enter preferred move-in date'
              onChange={(date) => {
                formik.setFieldTouched('tenancy_start', true, true)
                if (date === null) {
                  setMoveInDate(null)
                  formik.setFieldValue('tenancy_start', '')
                } else {
                  setMoveInDate(date)
                  formik.setFieldValue('tenancy_start', formatDate(date))
                }
              }}
              className='form-control form-control-lg form-control-solid'
            />
            <div className='h-20px'>
              {formik.touched.tenancy_start && formik.errors.tenancy_start && (
                <div className='fv-help-block color-red'>{formik.errors.tenancy_start}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Preferred Move-In Date */}
          {/*Begin::Form Group Preferred Rental Duration in Years */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Preferred Rental Duration in Years</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter preferred rental duration'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter preferred rental duration'
              {...formik.getFieldProps('tenancy_period')}
              name='tenancy_period'
            />
            <div className='h-20px'>
              {formik.touched.tenancy_period && formik.errors.tenancy_period && (
                <div className='fv-help-block color-red'>{formik.errors.tenancy_period}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Preferred Rental Duration in Years */}
        </div>
        {/* End: Section Property Preferences */}

        <hr className='py-2 text-primary' />

        {/* Begin: Section Income / Employment Details */}
        {/* Begin: Heading Income / Employment Details */}
        <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
          Income / Employment Details
        </h2>
        {/* End: Heading Income / Employment Details */}
        <div className='row justify-content-between w-100'>
          {/*Begin::Form Group Employment type */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>
                <button
                  type='button'
                  className={`btn btn-sm fw-bold px-2 py-1 mx-1 ${
                    employmentType === 'Salaried' ? 'btn-primary' : 'btn-secondary'
                  } `}
                  onClick={() => {
                    setEmploymentType('Salaried')
                    formik.setFieldValue('employment_type', 'Salaried', true)
                  }}
                >
                  Salaried
                </button>
                <span>/</span>
                <button
                  type='button'
                  className={`btn btn-sm fw-bold px-2 py-1 ms-1 ${
                    employmentType === 'self employment' ? 'btn-primary' : 'btn-secondary'
                  } `}
                  onClick={() => {
                    setEmploymentType('self employment')
                    formik.setFieldValue('employment_type', 'self employment', true)
                  }}
                >
                  Self Employed
                </button>
              </span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Select salaried / self employed and mention current employer name / business name based on your selection'
              ></i>
            </label>
            {employmentType === 'Salaried' ? (
              <>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter current employer'
                  {...formik.getFieldProps('current_employer')}
                  name='current_employer'
                  onChange={(e) => {
                    formik.setFieldValue('employment_type', 'Salaried', true)
                    formik.setFieldValue('current_employer', e.target.value, true)
                  }}
                />
                <div className='h-20px'>
                  {formik.touched.current_employer && formik.errors.current_employer && (
                    <div className='fv-help-block color-red'>{formik.errors.current_employer}</div>
                  )}
                </div>
              </>
            ) : (
              <>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter business name'
                  {...formik.getFieldProps('business_name')}
                  name='business_name'
                  onChange={(e) => {
                    formik.setFieldValue('employment_type', 'self employment', true)
                    formik.setFieldValue('business_name', e.target.value, true)
                  }}
                />
                <div className='h-20px'>
                  {formik.touched.business_name && formik.errors.business_name && (
                    <div className='fv-help-block color-red'>{formik.errors.business_name}</div>
                  )}
                </div>
              </>
            )}
          </div>
          {/*End::Form Group Employment type */}
          {/*Begin::Form Group Monthly Income */}
          <div className="col-lg-6 col-12 fv-row mb-2">
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Monthly Income</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter monthly income'
              ></i>
            </label>
            <select
              className='form-select form-select-solid'
              placeholder='Enter monthly income'
              {...formik.getFieldProps('monthly_income')}
              name='monthly_income'
            >
              <option className='bg-color-gray' value=''>
                Select monthly income
              </option>
              <option value='Below ₹10,000'>Below ₹10,000</option>
              <option value='₹10,000 - ₹25,000'>₹10,000 - ₹25,000</option>
              <option value='₹25,000 - ₹50,000'>₹25,000 - ₹50,000</option>
              <option value='₹50,000 - ₹1,00,000'>₹50,000 - ₹1,00,000</option>
              <option value='₹1,00,000 - ₹1,50,000'>₹1,00,000 - ₹1,50,000</option>
              <option value='₹1,50,000 - ₹2,00,000'>₹1,50,000 - ₹2,00,000</option>
              <option value='Above ₹2,00,000'>Above ₹2,00,000</option>
            </select>
            <div className='h-20px'>
              {formik.touched.monthly_income && formik.errors.monthly_income && (
                <div className='fv-help-block color-red'>{formik.errors.monthly_income}</div>
              )}
            </div>
          </div>
          {/*End::Form Group Monthly Income */}
          {/*Begin::Form Group Length of Employment in Years */}
          {employmentType === 'Salaried' && (
            <div className="col-lg-6 col-12 fv-row mb-2">
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span>Length of Employment in Years</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter length of employment'
                ></i>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Enter length of employment'
                {...formik.getFieldProps('employment_length')}
                name='employment_length'
              />
              <div className='h-20px'>
                {formik.touched.employment_length && formik.errors.employment_length && (
                  <div className='fv-help-block color-red'>{formik.errors.employment_length}</div>
                )}
              </div>
            </div>
          )}
          {/*End::Form Group Length of Employment in Years */}
        </div>
        {/* End: Section Income / Employment Details */}
        {/*Begin::Form Group Other Requirements*/}
        <div className='row justify-content-between mb-2 w-100'>
          <div className='col-12'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Other Requirements</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter other requirements'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter other requirements'
            {...formik.getFieldProps('other_requirement')}
            name='other_requirement'
          />
          <div className='h-20px'>
            {formik.touched.other_requirement && formik.errors.other_requirement && (
              <div className='fv-help-block color-red'>{formik.errors.other_requirement}</div>
            )}
          </div>
          </div>
        </div>
        {/*End::Form Group Other Requirements*/}

        {/*Begin::Form Group Verify checkbox*/}
        <div className='d-flex align-items-center'>
          <div className='form-check form-check-sm form-check-custom form-check-solid'>
            <input
              style={{accentColor: '#ac4481'}}
              className='form bg-primary me-4'
              type='checkbox'
              value='True'
              id='verify'
              data-kt-check='true'
              data-kt-check-target='.widget-9-check'
              onChange={(e) => {
                formik.setFieldValue('verifyCheckbox', e.target.checked ? true : '')
              }}
            />
          </div>
          <label htmlFor='verify' className='fs-7 fw-semibold'>
            I hereby certify that, to the best of my knowledge, the provided information is true and
            accurate.
          </label>
        </div>
        <div className='h-20px'>
          {formik.touched.verifyCheckbox && formik.errors.verifyCheckbox && (
            <div className='fv-help-block color-red'>{formik.errors.verifyCheckbox}</div>
          )}
        </div>
        {/*End::Form Group Verify checkbox*/}
        <div className='d-flex justify-content-center'>
          {/* Begin:: submit button */}
          {/* <button
            type='submit'
            className={`btn btn-lg ${
              formik.isSubmitting || !formik.isValid || submitBtnLoading
                ? 'btn-secondary'
                : 'btn-primary'
            } mt-5`}
            data-kt-stepper-action='submit'
            disabled={formik.isSubmitting || !formik.isValid || submitBtnLoading}
          ></button> */}
          <button
            type='submit'
            className='btn btn-lg btn-primary mt-5'
            data-kt-stepper-action='submit'
            disabled={submitBtnLoading}
          >
            {submitBtnLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Processing...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Submit'
            )}
          </button>
          {/* Begin:: submit button */}
        </div>
      </form>
      {/* End: form */}
    </div>
  )
}
export default NewLeadsForm
